<div class="mb-4 flex flex-col">
  <div class="flex items-center justify-between">
    <h3 class="text-neutral-500">Візити партнера</h3>
    @if (!loading()) {
      <button
        class="btn btn-secondary text-sm"
        (click)="fetchSuggestions()"
      >
        Оновити
      </button>
    }
  </div>
</div>

@if (!loading()) {
  <div class="mb-4 flex items-center justify-between">
    @if (suggestions().length > 1) {
      <span class="flex flex-col">
        <span class="text-md text-gray-2"> Оберіть візит, з яким буде здійснена синхронізація </span>
        <span class="text-md text-gray-2"> Знайдено візитів: {{ suggestions().length }}. </span>
      </span>
    }
  </div>

  <div class="max-h-[22rem] overflow-y-auto overflow-x-hidden">
    @for (suggestion of suggestions(); track suggestion.partnerId + suggestion.locationId + suggestion.doctorId) {
      <div
        class="mb-6"
        [ngClass]="{ 'mr-2': suggestions().length > 3 }"
      >
        <hm-suggestion-item
          [suggestionData]="suggestion"
          [selected]="isSuggestionSelected(suggestion)"
          (selectionChange)="selectSuggestion($event)"
        ></hm-suggestion-item>
      </div>
    }

    @if (suggestionsWarning()) {
      <shared-warning-message [text]="suggestionsWarning()"></shared-warning-message>
    }
  </div>
} @else {
  <div class="my-2 flex items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
